import { render, staticRenderFns } from "./file-preview-gallery-empty-block.vue?vue&type=template&id=58e9ebfe"
import script from "./file-preview-gallery-empty-block.vue?vue&type=script&lang=js"
export * from "./file-preview-gallery-empty-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports